import React from "react";
import { NOOP } from "./Game";
import { segment, stateToColor } from "./utils";

function Row(props) {
  return (
    <div className="flex">
      {props.keymap.map((entry, i) => {
        const { key, state } = entry;
        const isKeyEnabled = (props.enabledKeys || []).includes(key);
        const color = !isKeyEnabled
          ? stateToColor(state) + "/30 border-slate-100/30 cursor-not-allowed"
          : stateToColor(state) + " border-slate-400 cursor-pointer";
        return (
          <div
            onClick={isKeyEnabled ? (e) => props.onKeypress(key) : () => {}}
            className={"w-8 h-9 my-2 mx-1 px-2 py-0 rounded border-2 " + color}
            key={key}
          >
            <div className="opacity-100">{key}</div>
          </div>
        );
      })}
    </div>
  );
}

export default function Keyboard(props) {
  const segments = segment(props.keymap, 4);
  return (
    <div className="w-full border-0 border-t-2 border-slate-200 text-xl">
      <div className="py-3 mx-2 flex flex-col overflow-x-scroll">
        {segments.map((s, i) => (
          <Row
            key={i}
            keymap={s}
            onKeypress={props.onKeypress}
            enabledKeys={props.enabledKeys}
          />
        ))}
      </div>
      <div className="flex mb-3 ml-2 mt-0 mr-2">
        <div
          className={
            props.onEnter === NOOP
              ? "cursor-not-allowed rounded px-4 text-center w-1/2 h-11 m-1 mr-2 py-2 text-base font-semibold uppercase inline-block bg-slate-100 border-2 border-slate-100"
              : "cursor-pointer rounded px-4 text-center w-1/2 h-11 m-1 mr-2 py-2 text-base font-semibold uppercase inline-block bg-slate-200 border-2 border-slate-400"
          }
          onClick={props.onEnter}
        >
          Enter
        </div>
        <div
          className={
            props.onDelete === NOOP
              ? "cursor-not-allowed rounded px-4 text-center w-1/2 h-11 m-1 mr-2 py-2 text-base font-semibold uppercase inline-block bg-slate-100 border-2 border-slate-100"
              : "cursor-pointer rounded px-4 text-center w-1/2 h-11 m-1 mr-2 py-2 text-base font-semibold uppercase inline-block bg-slate-200 border-2 border-slate-400"
          }
          onClick={props.onDelete}
        >
          Delete
        </div>
      </div>
    </div>
  );
}
